import {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';

import {InputText} from 'primereact/inputtext';
import {TabView, TabPanel} from 'primereact/tabview';
import {Button} from 'primereact/button';

import {InvoiceSettingDefaultService} from './InvoiceSettingDefaultService';

import {Settings} from './item/Settings';
import {TenantInvoiceSettingMasterService} from './TenantInvoiceSettingMasterService';

import {ToastService} from '../../../AppToast';
import {useTranslation} from '../../../shared/language';

export const Update = () => {
  const {t} = useTranslation();

  const {id} = useParams();

  const [submitting, setSubmitting] = useState(false);
  const [name, setName] = useState('');
  const [typeInvoiceId, setTypeInvoiceId] = useState('');
  const [typeInvoiceName, setTypeInvoiceName] = useState('');
  const [invoiceGroups, setInvoiceGroups] = useState([]);
  const [invoiceGroupSettings, setInvoiceGroupSettings] = useState({});
  const [allSettings, setAllSettings] = useState([]);

  useEffect(() => {
    if (id) {
      TenantInvoiceSettingMasterService.get(id).then((data) => {
        setName(data.name);
        setTypeInvoiceId(data.typeInvoiceId);
        setTypeInvoiceName(data.typeInvoiceName);

        const _invoiceGroupSettings = {}, _allSettings = [];
        data.invoiceSettings.forEach((setting) => {
          if (!_invoiceGroupSettings[setting.groupTypeCode]) {
            _invoiceGroupSettings[setting.groupTypeCode] = [];
          }
          if (setting.defaultValue === null) {
            setting.defaultValue = '';
          }
          _invoiceGroupSettings[setting.groupTypeCode].push(setting);
          _allSettings.push(setting);
        });
        setInvoiceGroupSettings(_invoiceGroupSettings);
        setAllSettings(_allSettings);
      });
    }
  }, [id]);

  useEffect(() => {
    InvoiceSettingDefaultService.getGroupTypeCode().then((data) => {
      const _invoiceGroups = [];
      Object.keys(data).forEach(key => {
        _invoiceGroups.push({value: key, label: data[key]});
      });
      setInvoiceGroups(_invoiceGroups);
    });
  }, []);

  const sortItems = (group) => {
    const _invoiceGroupSettings: any = {...invoiceGroupSettings};
    const df = 1000 * 1000;
    _invoiceGroupSettings[group].sort((a, b) => {
      return (a.orders || df) - (b.orders || df);
    });
    setInvoiceGroupSettings(_invoiceGroupSettings);
  }

  const setItems = (group, items) => {
    const _invoiceGroupSettings: any = {...invoiceGroupSettings};
    _invoiceGroupSettings[group] = items;
    setInvoiceGroupSettings(_invoiceGroupSettings);
  }

  const back = () => {
    window.location.hash = '/he-thong/cau-hinh-hoa-don';
  }

  const handleSubmit = () => {
    if (!submitting) {
      if (name && name.trim()) {
        if (typeInvoiceId) {
          setSubmitting(true);

          const invoiceSettings = [];
          Object.keys(invoiceGroupSettings).forEach((key) => {
            invoiceSettings.push(...invoiceGroupSettings[key]);
          });

          TenantInvoiceSettingMasterService.update(id, {
            typeInvoiceId,
            name,
            invoiceSettings: invoiceSettings
          }).then(() => {
            ToastService.success();
            window.location.hash = '/he-thong/cau-hinh-hoa-don';
          }).catch(() => {
            setSubmitting(false);
          });
        } else {
          ToastService.error(t('system.configCodeRequired'));
        }
      } else {
        ToastService.error(t('system.invoiceTypeRequired'));
      }
    }
  }

  return (
    <div className="mt-1 pl-3 pr-3 pt-2">
      <div className="p-fluid formgrid grid">
        <div className="field col-12 md:col-6">
          <label htmlFor="name">{t('system.configCode')}</label>
          <InputText id="name" value={name} readOnly/>
        </div>
        <div className="field col-12 md:col-6">
          <label htmlFor="typeInvoiceId">{t('system.invoiceType')}</label>
          <InputText id="typeInvoiceId" value={typeInvoiceName} readOnly/>
        </div>
      </div>

      <TabView>
        {invoiceGroups.map((group, index) => {
          return (
            <TabPanel key={index} header={group.label}>
              <Settings items={invoiceGroupSettings[group.value]} setItems={setItems} invoiceGroups={invoiceGroups} allSettings={allSettings}
                        group={group.value} sortItems={sortItems} tenantInvoiceSettingMasterId={id}/>
            </TabPanel>
          )
        })}
      </TabView>

      <div className="flex justify-content-end mt-3">
        <Button label={t('system.exit')} icon="pi pi-times" onClick={back} className="p-button-text p-button-sm mr-2"/>
        <Button label={t('common.save')} icon="pi pi-check" onClick={handleSubmit} loading={submitting} className="p-button-sm"/>
      </div>
    </div>
  );
}
